import ProjectList from "./components/ProjectList";
import Team from "./components/Team";

export default function Sidebar() {
  return (
    <div className="sidebar">
      {/* Projects List */}
      <ProjectList />
      {/* Team Members */}
      <Team />
    </div>
  );
}
